export default "const a = \"\",\nb = \"\",\nc = \"\";"